import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeHighlightedSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12 4.238l-4 2.25v4.545l4 2.25 4-2.25V6.488z" />
        <path d="M13.488.449a3 3 0 00-2.976 0l-5 2.857A3 3 0 004 5.911v5.679a3 3 0 001.512 2.604l.613.35v7.376c0 1.572 1.819 2.446 3.046 1.464L12 21.12l2.829 2.263c1.227.982 3.046.108 3.046-1.464v-7.375l.613-.35A3 3 0 0020 11.59V5.91a3 3 0 00-1.512-2.604zm-1.984 1.736a1 1 0 01.992 0l5 2.858A1 1 0 0118 5.91v5.679a1 1 0 01-.504.868l-5 2.857a1 1 0 01-.992 0l-5-2.857A1 1 0 016 11.59V5.91a1 1 0 01.504-.867z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeHighlightedSmall;
